
class EquipmentModel {
    id: number;
    title: string;
    isActive: boolean;

    constructor(
        id: number,
        title: string,
        isActive: boolean,
    ) {
        this.id = id;
        this.title = title;
        this.isActive = isActive;
    }

    public static fromJson(json: any): EquipmentModel {
        return new EquipmentModel(
            json["id"],
            json["title"],
            json["isActive"],
        );
    }
}


export interface EquipmentGetPayloadFilterModel {
    id?: number;
    title?: string;
    isActive?: number;
}

export interface EquipmentGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: EquipmentGetPayloadFilterModel;
}


export interface EquipmentPayloadModel {
    id: number;
    title: string;
    isActive: boolean;

}
export default EquipmentModel;
